// All coordinates use the layout viewport, including visual viewport offsets.
export const getTooltipPosition = (anchor, size, viewport) => {
  const margin = 12;
  const gap = 8;
  const leftEdge = (viewport.left || 0) + margin;
  const topEdge = (viewport.top || 0) + margin;
  const width = Math.max(0, viewport.width - margin * 2);
  const maxHeight = Math.max(0, viewport.height - margin * 2);
  const popupWidth = Math.min(size.width, width);
  const popupHeight = Math.min(size.height, maxHeight);
  const rightEdge = leftEdge + width;
  const bottomEdge = topEdge + maxHeight;
  const above = anchor.top - gap - popupHeight;
  const below = anchor.bottom + gap;
  const preferredTop = above >= topEdge ? above : below;
  const top = Math.max(topEdge, Math.min(preferredTop, bottomEdge - popupHeight));
  const left = Math.max(leftEdge, Math.min(anchor.left + anchor.width / 2 - popupWidth / 2, rightEdge - popupWidth));
  return { top, left, maxHeight, maxWidth: width };
};
